import {ReactionType} from "./Video";
import {JsonAny} from "../../Types";
import parseISO from "date-fns/parseISO";

export interface VideoReaction {
    id: number;
    videoId: number;
    userId: number;
    type: ReactionType;
    reactionTimeMillis: number;
    created: Date;
}

export interface VideoReactionChangeSet {
    id: number;
    userId: number;
    type: ReactionType;
    reactionTimeMillis: number;
}

export function parseVideoReaction(json: JsonAny): VideoReaction {
    return {
        ...json,
        created: parseISO(json.created)
   };
}
